<template>
  
<v-row class="pa-0">
  <v-col cols="12" md="12" class="d-flex align-center flex-row">
    <v-select mandatory v-model="prelevato_id" :items="prelevato_choices" label="Prelevato carcassa" hide-details   item-title="label"  class="mb-6" />
  </v-col>
</v-row>


</template>

<script setup>

import { onMounted } from "vue";

import baseData from '@/assets/catalog/TrackerForms.json'

const prelevato_id = defineModel("prelevato_id")

if (!prelevato_id.value){
  prelevato_id.value = 1
}

const prelevato_choices = baseData.lookup.prelevato


onMounted(() => {
})

</script>

<style scoped>
</style>
